import * as yup from 'yup';
import { requiredErrorMessage } from 'shared/consts';

export const validationSchema = yup.object().shape({
  displayed_name: yup.string().required(requiredErrorMessage),
  country_id: yup.number().required(requiredErrorMessage),
  priority: yup
    .mixed()
    .nullable()
    .test('isNull', 'Поле не может быть пустым', (value) => value !== null),
  limit_per_day: yup
    .mixed()
    .nullable()
    .test('isNull', 'Поле не может быть пустым', (value) => value !== null)
    .test('isInteger', 'Число должно быть целым', (value) => Number.isInteger(Number(value)))
    .test('limit', 'Поле не может быть меньше 1 и больше 20', (value) => {
      if (value !== null && value !== undefined) {
        return value > 0 && value < 21;
      }
    }),
  limit_per_month: yup
    .mixed()
    .nullable()
    .test('isNull', 'Поле не может быть пустым', (value) => value !== null)
    .test('isInteger', 'Число должно быть целым', (value) => Number.isInteger(Number(value)))
    .test('limit', 'Поле не может быть меньше 1', (value) => {
      if (value !== null && value !== undefined) {
        return value > 0;
      }
    }),
  retry_time: yup
    .mixed()
    .nullable()
    .test('isNull', 'Поле не может быть пустым', (value) => value !== null)
    .test('isInteger', 'Число должно быть целым', (value) => Number.isInteger(Number(value)))
    .test('limit', 'Поле не может быть меньше 1 и больше 255', (value) => {
      if (value !== null && value !== undefined) {
        return value > 0 && value < 256;
      }
    }),
  is_enabled: yup.boolean(),
});
